// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  hmr: false,
  oauth_token: '1_wfj2y7d2phwsgw0w4w04ko0kw0000g4s48ow88ggg480wgwow',
  oauth_secret: '3mm8ox14ham80s0sk8o8kc4go0wks8kw0gck40cw4kkw8w8wk8',
  base_url: 'https://api.test.tellow.nl',
  track_url: 'http://track.tellow.m4m',
  billing_service_url: 'https://billing.test.tellow.nl',
  grant: 'password',
  grant_2fa: 'https://grants.tellow.nl/web',
  remote_login_template: 'https://app.test.tellow.nl/login/enter;access_token=%s;refresh_token=%s;administration_id=%s',
}



// WEBPACK FOOTER //
// ./src/environments/environment.ts